import { useIsMobile } from '../../../hooks/useIsMobile';
import { t } from '../../../translation/translation';
import './styles.css'

type TMozaicItemProps = {
    titleKey: string;
    descriptionKey: string;
    image: string;
    isSquare?: boolean;
};

const MozaicItem = ({ titleKey, descriptionKey, image, isSquare = false }: TMozaicItemProps) => {

    const isMobile = useIsMobile()

    if (isSquare) {
        return (
            <div className={`section-mozaic-item-square ${isMobile ? 'mobile' : ''}`}>
                <div className='section-mozaic-item-header-square'>
                    <h4>{t(titleKey)}</h4>
                    <p>{t(descriptionKey)}</p>
                </div>
                <div className='section-mozaic-item-image-square'>
                    <img src={image} alt='Description' />
                </div>
            </div>
        )
    }

    return (
        <div className={`section-mozaic-item`}>
            <div className='section-mozaic-item-header'>
                <h4>{t(titleKey)}</h4>
                <p>{t(descriptionKey)}</p>
            </div>
            <div className='section-mozaic-item-image'>
                <img src={image} alt='Description' />
            </div>
        </div>
    );
};

export default MozaicItem
